<div style="display: flex;flex-direction: column;flex: 1; overflow: auto;">
    <div mat-dialog-title>
        <span *ngIf="announcements.length > 0">New Announcements</span> 
        <span *ngIf="announcements.length == 0">Daily Announcements </span>
    </div>
    

    <mat-dialog-content>
        <div style="display: flex; flex-direction: column; flex: 1" *ngIf="v10">
            <mat-accordion *ngIf="districtAnnouncements.length > 0" style="margin: 0px;">
                <mat-expansion-panel class="mat-elevation-z0 bottomBorder" [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="robotoMedium" style="font-size: 14pt" translate>
                            District ({{districtAnnouncements.length}})
                        </mat-panel-title>
                        <mat-panel-description>
                            <!--No Description-->
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <!--Expand Content-->
                    <div style="margin-bottom: 10px" *ngFor="let da of districtAnnouncements">
                        <div class="robotoMedium" style="font-size: 11pt;">
                            <span class="newBadge" *ngIf="da.IsNewSinceLastLogin == 1" translate>NEW</span><span
                                *ngIf="da.IsNewSinceLastLogin == 1"> - </span>{{da.StartDate | date: 'MM/dd/yy'}} -
                            <span style="font-weight: bold">{{da.Title}}</span>
                        </div>
                        <div>
                            <div #textArea class="announcementText"
                                 style="-webkit-box-orient: vertical; margin-right: 30px"
                                 [innerHTML]="da.Announcement" ExternalLink></div>
                            <span *ngIf="da.Overflow"><a
                                    style="display: flex;justify-content: flex-end;position: relative;top: -18px;"
                                    (click)="moreClick(da)" translate>More</a></span>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion *ngIf="schoolAnnouncements.length > 0" style="margin: 0px;">
                <mat-expansion-panel class="mat-elevation-z0 bottomBorder" [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="robotoMedium" style="font-size: 14pt" translate>
                            School ({{schoolAnnouncements.length}})
                        </mat-panel-title>
                        <mat-panel-description>
                            <!--No Description-->
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <!--Expand Content-->
                    <div style="margin-bottom: 10px" *ngFor="let sa of schoolAnnouncements">
                        <div class="robotoMedium" style="font-size: 11pt;">
                            <span class="newBadge" *ngIf="sa.IsNewSinceLastLogin == 1" translate>NEW</span><span
                                *ngIf="sa.IsNewSinceLastLogin == 1"> - </span>{{sa.StartDate | date: 'MM/dd/yy'}} -
                            <span style="font-weight: bold">{{sa.Title}}</span>
                        </div>
                        <div>
                            <div #textArea class="announcementText"
                                 style="-webkit-box-orient: vertical; margin-right: 30px"
                                 [innerHTML]="sa.Announcement" ExternalLink></div>
                            <span *ngIf="sa.Overflow"><a
                                    style="display: flex;justify-content: flex-end;position: relative;top: -18px;"
                                    (click)="moreClick(sa)" translate>More</a></span>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-accordion *ngIf="classroomAnnouncements.length > 0" style="margin: 0px;">
                <mat-expansion-panel class="mat-elevation-z0 bottomBorder" [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="robotoMedium" style="font-size: 14pt" translate>
                            Class ({{classroomAnnouncements.length}})
                        </mat-panel-title>
                        <mat-panel-description>
                            <!--No Description-->
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    <!--Expand Content-->
                    <div style="margin-bottom: 10px" *ngFor="let ca of classroomAnnouncements">
                        <div class="robotoMedium" style="font-size: 11pt;">
                            <span class="newBadge" *ngIf="ca.IsNewSinceLastLogin == 1" translate>NEW</span><span
                                *ngIf="ca.IsNewSinceLastLogin == 1"> - </span>{{ca.StartDate | date: 'MM/dd/yy'}} -
                            <span style="font-weight: bold">{{ca.Title}}</span>
                        </div>
                        <div>
                            <div #textArea class="announcementText"
                                 style="-webkit-box-orient: vertical; margin-right: 30px"
                                 [innerHTML]="ca.Announcement" ExternalLink></div>
                            <span *ngIf="ca.Overflow"><a
                                    style="display: flex;justify-content: flex-end;position: relative;top: -18px;"
                                    (click)="moreClick(ca)" translate>More</a></span>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div style="display: flex; flex-direction: column; flex: 1" *ngIf="announcements.length > 0 && !v10">
            <div *ngIf="announcements.length > 0">
                <ng-container *ngFor="let tableDatum of tableData; let i = index">
                    <ng-container *ngIf="showTableFlags[i]">
                    <h1 role="heading" class="sectionHeader" translate>{{sectionNames[i]}}</h1>
                    <announcement-table [tableData]="tableDatum" [classAnnouncements]="i == 2"></announcement-table>
                   </ng-container>
                  </ng-container>
                  <ng-container *ngFor="let school of schoolName">
                    <ng-container>
                      <h1 role="heading" class="sectionHeader" translate>{{school}}</h1>
                      <announcement-table [tableData]="siteAnnouncement | newAnnouncementsModalFilter:school"  [classAnnouncements]="i == 2"></announcement-table>
                     </ng-container>
                  </ng-container>
            </div>
        </div>
        <div *ngIf="siteDailyAnnouncement.length > 0 && announcements.length ==0 && !v10">
            <ng-container *ngFor="let tableDatadaily of tableDailyData; let i = index">
                <ng-container *ngIf="showTableDailyFlags[i]">
                    <h1 role="heading" class="sectionHeader" translate>{{sectionNames[i]}}</h1>
                    <announcement-table [tableData]="tableDatadaily" [classAnnouncements]="i == 2"></announcement-table>
                </ng-container>
            </ng-container>
            <ng-container *ngFor="let school of schoolNameDaily">
                <ng-container>
                    <h1 role="heading" class="sectionHeader" translate>{{school}}</h1>
                    <announcement-table [tableData]="siteDailyAnnouncementTable | newAnnouncementsModalFilter:school"  [classAnnouncements]="i == 2"></announcement-table>
                </ng-container>
            </ng-container> 
        </div>
    </mat-dialog-content>
    

    <mat-dialog-actions>
        <div class="flex-footer-left">
            <expand-collapse-buttons [expandEmitter]="toggleAllRows"></expand-collapse-buttons>
        </div>
        <div class="flex-footer-right">
            <tyl-button id="allAnnouncementsButton" image="next arrow.png" *ngIf="announcements.length > 0" label="All Announcements" (clickEvent)="allAnnouncementsClick()"></tyl-button>
            <tyl-button id="cancelButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
        </div>
    </mat-dialog-actions>
</div>



